import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import API from './services/api';

const ResetPassword = () => {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleResetPassword = async (e) => {
        e.preventDefault();

        try {
            const response = await API.post(`/api/auth/reset-password/${token}`, { password });
            setMessage(response.data.message);
            setError('');
        } catch (err) {
            const apiError = err.response?.data?.message || err.response?.data?.error;
            setError(apiError || 'An error occurred');
            setMessage('');
        }
    };

    return (
        <div className="reset-password-container">
            <h2>Reset Password</h2>
            <form onSubmit={handleResetPassword}>
                <div className="form-group">
                    <label>New Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Reset Password</button>
            </form>
            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}
        </div>
    );
};

export default ResetPassword;